import { Box, Typography } from '@mui/material';
import { CheckCircleOutlined } from '@ant-design/icons';
import { emphasize, styled } from '@mui/material/styles';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Chip from '@mui/material/Chip';
import HomeIcon from '@mui/icons-material/Home';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import '../../../Styles/StyleHome.css';
import ValidationPanel from './ValidationPanel';

const StyledBreadcrumb = styled(Chip)(({ theme }) => {
  const backgroundColor =
    theme.palette.mode === 'light'
      ? theme.palette.grey[100]
      : theme.palette.grey[800];
  return {
    backgroundColor,
    height: theme.spacing(3),
    color: theme.palette.text.primary,
    fontWeight: theme.typography.fontWeightRegular,
    '&:hover, &:focus': {
      backgroundColor: emphasize(backgroundColor, 0.06),
    },
    '&:active': {
      boxShadow: theme.shadows[1],
      backgroundColor: emphasize(backgroundColor, 0.12),
    },
  };
}) as typeof Chip;

// Page dédiée (menu séparé de "Validation KYC") pour le rôle validateur —
// ne montre que les demandes de modification d'identité signataire/
// mandataire (TypeModification SIGNATAIRE_MODIFICATION/PROCURATION_MODIFICATION),
// via le même ValidationPanel que /kyc/validation, filtré par props.
export default function KycIdentiteRelationValidationPage() {
  return (
    <div className="tab">
      <Box className="formTitle">
        <Breadcrumbs aria-label="breadcrumb">
          <StyledBreadcrumb component="a" href="/" label="Home" icon={<HomeIcon fontSize="small" />} />
          <StyledBreadcrumb component="a" href="#" label="KYC" />
          <StyledBreadcrumb label="Validation identité signataire / procuration" deleteIcon={<ExpandMoreIcon />} />
        </Breadcrumbs>
      </Box>

      <div className="clientP">
        <Box sx={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 1,
          mb: 2,
          backgroundColor: 'var(--primaryColor)',
          color: 'var(--white)',
          padding: '8px 16px',
          borderRadius: 1,
          borderBottom: '5px solid var(--darkColor)',
          whiteSpace: 'nowrap',
        }}>
          <CheckCircleOutlined style={{ color: 'var(--white)' }} />
          <Typography fontWeight={600} sx={{ color: 'var(--white)' }}>Validation identité signataire / procuration</Typography>
        </Box>

        <ValidationPanel
          typesModification={['SIGNATAIRE_MODIFICATION', 'PROCURATION_MODIFICATION']}
          sousTitre="Demandes de modification d'identité signataire/procuration, tous clients"
        />
      </div>
    </div>
  );
}
